var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import TimePicker from 'react-time-picker';
import { getDateFnsLocaleTimeFormat } from '../../util-components/datetime';
import { Styled } from './style';
var CustomTimePicker = /** @class */ (function (_super) {
    __extends(CustomTimePicker, _super);
    function CustomTimePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (value) {
            // Override max attribute on minute/second input to allow 24h format
            if (navigator.language === 'en-GB' || _this.props.locale === 'en-GB') {
                var domNode = _this.timePickerRef.current;
                var minuteInput = domNode.querySelector('.react-time-picker__inputGroup__minute');
                var secondInput = domNode.querySelector('.react-time-picker__inputGroup__second');
                if (value.substr(0, 2) === '24') {
                    minuteInput === null || minuteInput === void 0 ? void 0 : minuteInput.setAttribute('max', '00');
                    secondInput === null || secondInput === void 0 ? void 0 : secondInput.setAttribute('max', '00');
                }
            }
            _this.props.onChange && _this.props.onChange(value);
        };
        _this.setTimeFormat = function (locale, showSecond) {
            if (!showSecond) {
                return getDateFnsLocaleTimeFormat(locale).replace(':ss', '');
            }
            return getDateFnsLocaleTimeFormat(locale);
        };
        _this.timePickerRef = React.createRef();
        return _this;
    }
    CustomTimePicker.prototype.componentDidMount = function () {
        var _a;
        // Override max attribute on hour input to allow 24h format
        if (navigator.language === 'en-GB' || this.props.locale === 'en-GB') {
            var domNode = this.timePickerRef.current;
            var hourInput = domNode.querySelector('.react-time-picker__inputGroup__hour');
            if ((_a = this.props.maxTime) === null || _a === void 0 ? void 0 : _a.startsWith('24')) {
                hourInput === null || hourInput === void 0 ? void 0 : hourInput.setAttribute('max', '24');
            }
        }
    };
    CustomTimePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, compact = _a.compact, disabled = _a.disabled, locale = _a.locale, minTime = _a.minTime, maxTime = _a.maxTime, showSecond = _a.showSecond, style = _a.style, value = _a.value;
        return (React.createElement(Styled, { className: className, compact: compact, style: style, disabled: disabled, ref: this.timePickerRef },
            React.createElement(TimePicker, { onChange: function (val) { return _this.handleChange(val); }, showLeadingZeros: true, disabled: disabled, maxDetail: showSecond ? "second" : "minute", format: this.setTimeFormat(locale, showSecond), value: value, minTime: minTime, maxTime: maxTime, disableClock: true, clearIcon: null })));
    };
    return CustomTimePicker;
}(React.Component));
export default CustomTimePicker;
//# sourceMappingURL=index.js.map